import * as React from 'react';

import { PropertyInfoSubSectionViewModel, SectionType } from 'models';

import { UitkHeading } from 'uitk-react-text';
import { UitkLayoutColumnsNoBreak } from 'uitk-react-layout-columns';

import { SectionPlainList } from './section-list';

interface SectionsProps {
  section?: PropertyInfoSubSectionViewModel;
  dataStid: string;
  uitkHeadingLevel?: any;
  movePropertyTitle?: boolean;
}

export const Sections = ({ section, dataStid, uitkHeadingLevel = 4, movePropertyTitle }: SectionsProps) => {
  if (!section || !dataStid) {
    return null;
  }

  const isInBulletedList =
    section.formattedDescriptions &&
    section.formattedDescriptions[0] &&
    section.formattedDescriptions[0].sectionType === SectionType.BULLETED_LIST;

  return (
    <>
      {section.title &&
        section.formattedDescriptions &&
        section.formattedDescriptions.length > 0 && (
          <>
            {isInBulletedList ? (
              <LayoutColumns section={section} uitkHeadingLevel={uitkHeadingLevel} dataStid={dataStid} />
            ) : (
              <ContinuousList
                section={section}
                uitkHeadingLevel={uitkHeadingLevel}
                dataStid={dataStid}
                movePropertyTitle={movePropertyTitle}
              />
            )}
          </>
        )}
    </>
  );
};

Sections.displayName = 'Sections';

export const LayoutColumns = ({ section, uitkHeadingLevel, dataStid }) => (
  <UitkLayoutColumnsNoBreak>
    <div className="all-y-padding-three">
      <UitkHeading level={uitkHeadingLevel} size={500}>
        {section.title}
      </UitkHeading>
      {section.formattedDescriptions.map((formattedDescription, index) => (
        <SectionPlainList
          formattedDescription={formattedDescription}
          index={index}
          dataStid={dataStid}
          textType={formattedDescription.textType}
        />
      ))}
    </div>
  </UitkLayoutColumnsNoBreak>
);

export const ContinuousList = ({ section, uitkHeadingLevel, dataStid, movePropertyTitle }) => (
  <div className="all-y-padding-three">
    <UitkHeading level={uitkHeadingLevel} size={!movePropertyTitle ? 500 : 400}>
      {section.title}
    </UitkHeading>
    {section.formattedDescriptions.map((formattedDescription, index) => (
      <SectionPlainList
        formattedDescription={formattedDescription}
        index={index}
        dataStid={dataStid}
        textType={formattedDescription.textType}
      />
    ))}
  </div>
);
